<template>
  <v-input :hide-details="true" :rules="rules">
    <div class="admin-field-wrapper mt-2 mb-4">
      <div v-if="label" class="mb-2">{{ label }}</div>
      <slot />
    </div>
  </v-input>
</template>

<script>
export default {
  name: 'AdminFieldWrapper',
  components: {},
  props: {
    label: {
      type: String,
      default: null,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="css" scoped>
.admin-field-wrapper {
  width: 100%;
}
</style>
